const rules = [
  {
    text: "To enter a competition you must be 18 years old or over at the time of entry.",
  },
  {
    text: "Competitions are not open to employees (or members of their immediate families) of Maltalingua Ltd.",
  },
  {
    text: "The closing date is as specified in each competition, and Maltalingua reserves the right to amend the competition end date at any time.",
  },
  {
    text: "If you win a competition, we will notify you by post and/or e-mail and/or Facebook. The judges’ decision will be final, and no correspondence will be entered into.",
  },
  {
    text: "You can find out who has won a particular competition by sending  a stamped addressed envelope, marked with the name of the competition to Maltalingua Ltd, 2, Boxer House, B’kara Hill, St. Julians Malta.",
  },
  {
    text: "By entering the competition the winner agrees to participate in such promotional activity and material as Maltalingua may require.",
  },
  {
    text: "The panel of judges for each competition will be comprised of members of the marketing team of Maltalingua Ltd.",
  },
  { text: "The prize will not be transferable to another person" },
  {
    text: "No part of a prize is exchangeable for cash or any other prize.",
  },
  {
    text: "If an advertised prize is not available, we reserve the right to offer an alternative prize of equal or greater value.",
  },
  { text: "Incorrectly completed entries will be disqualified" },
];

export default rules;
